/** Typed route constants – never hard-code URLs in components. */
export const paths = {
  landing: '/',
  home: '/home',
  applications: {
    all: '/applications/all',
    actionRequired: '/applications/action-required',
    drafts: '/applications/drafts',
  },
  myPermits: '/my-permits',
  cashAndBilling: {
    certificateSummary: '/cash-and-billing/certificate-summary',
  },
  constructionProjects: '/construction-projects',
  ewr: '/ewr',
  inspections: '/inspections',
  meetings: '/meetings',
  news: '/news',
  resourcesAndTools: '/resources-and-tools',
  enforcement: {
    stopWorkOrders: '/enforcement/stop-work-orders',
    noticesOfInfraction: '/enforcement/notices-of-infraction',
  },
  aboutUs: '/about-us',
  contactUs: '/contact-us',
  payments: '/payments',
  documents: '/documents',
  help: '/help',
  account: '/account',
  settings: '/settings',
  notifications: '/notifications',
} as const;
